var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlayAudio = function SvgIconPlayAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.206 10.956 5.354 1.448a3.59 3.59 0 0 0-3.608.028A3.47 3.47 0 0 0-.001 4.493v19.015a3.47 3.47 0 0 0 1.747 3.016 3.59 3.59 0 0 0 3.608.028l16.852-9.508a3.48 3.48 0 0 0 0-6.088"
  })));
};
export default SvgIconPlayAudio;